module.exports = __webpack_public_path__ + "img/back-three.2a9ec68b.svg";